// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./web/sass/generate-template/index.scss
// module id = 965
// module chunks = 78 79 82